import CompanyConfigMailComponent from "../components/CompanyConfigMail";
import useCompanyConfigMail from "../hooks/useCompanyConfigMail";

const CompanyConfigMail = () => {
  const companyConfigMailProps = useCompanyConfigMail();
  return <CompanyConfigMailComponent {...companyConfigMailProps} />;
};

export default CompanyConfigMail;
